import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchInterviews = async (paginationModel) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/`, {
    params: paginationModel,
  });
  return response.data;
};

export const fetchTeamMembers = async ({ studyId, studyUrlType }) => {
  const response = await axiosServices.get(`${backendUrl}/${studyUrlType}/get-members/${studyId}/`);
  return response.data;
};
export const fetchShareTeamMembers = async ({ studyId, studyUrlType }) => {
  const response = await axiosServices.get(
    `${backendUrl}/${studyUrlType}/get-share-requests/${studyId}/`,
  );
  return response.data;
};

export const inviteTeamMember = async ({ studyId, studyUrlType, payload, returnUrl }) => {
  const response = await axiosServices.post(
    `${backendUrl}/${studyUrlType}/create-share-request/${studyId}/?return_url=${returnUrl}`,
    payload,
  );
  return response.data;
};

export const addPermissionToTeam = async ({ studyId, studyUrlType, payload, returnUrl }) => {
  const response = await axiosServices.post(
    `${backendUrl}/${studyUrlType}/create-share-request/${studyId}/?return_url=${returnUrl}`,
    payload,
  );
  return response.data;
};

export const deleteShareTeamMember = async ({ studyId, studyUrlType, email }) => {
  const response = await axiosServices.delete(
    `${backendUrl}/${studyUrlType}/delete-share-request/${studyId}/${email}/`,
  );
  return response.data;
};
export const removeTeamMember = async ({ studyId, studyUrlType, email }) => {
  const response = await axiosServices.delete(
    `${backendUrl}/${studyUrlType}/remove-member/${studyId}/?member_email=${email}`,
  );
  return response.data;
};
export const changeStudyOwner = async ({ studyId, studyUrlType, email, returnUrl }) => {
  const response = await axiosServices.post(
    `${backendUrl}/${studyUrlType}/change-owner-request/${studyId}/?new_owner_email=${encodeURIComponent(email)}&return_url=${returnUrl}`,
  );
  return response.data;
};
export const updateChatTitle = async (payload) => {
  console.log('🚀 ~ updateChatTitle ~ payload:', payload);
  const response = await axiosServices.patch(`${backendUrl}/update-chat-title`, payload);
  return response.data;
};
